import { RequestTypeStringsLookup } from '@src/utils/enums';

type ParseApiValidationErrorsResponse = {
  status: string;
  data: unknown;
};

export const parseApiValidationErrors = (response: ParseApiValidationErrorsResponse) => {
  if (response?.status === 'Validation Failed') {
    return response?.data;
  } else {
    return [];
  }
};

// Removes properties with null or undefined values from an object
export const cleanPayloadObject = (obj: Record<string, unknown>) =>
  Object.fromEntries(Object.entries(obj).filter(([_, v]) => v ?? false)); // eslint-disable-line @typescript-eslint/no-unused-vars

type GetBaseRequestValues = {
  hasPreviousFileNumber: boolean;
  location: string;
  natureOfActivity: string;
  nearestWaterbody?: string;
  parcelNumber?: string;
  previousFileNumbers?: string[];
  projectDescription: string;
  projectID?: number;
  projectName: string;
  projectPurpose: string;
  requestTypeId: string;
  siteDirections?: string;
};

export const getBaseRequestValues = ({
  hasPreviousFileNumber,
  projectDescription,
  projectPurpose,
  natureOfActivity,
  location,
  previousFileNumbers,
  projectName,
  projectID,
  requestTypeId,
  nearestWaterbody,
  parcelNumber,
  siteDirections,
}: GetBaseRequestValues) => ({
  hasPreviousFileNumber,
  location,
  natureOfActivity,
  previousFileNumbers,
  projectDescription,
  projectID,
  projectName: projectName,
  projectPurpose,
  request: {
    requestType: RequestTypeStringsLookup[requestTypeId],
  },
  requestID: undefined,
  version: undefined,
  nearestWaterbody,
  parcelNumber,
  siteDirections,
});
